import classNames from "classnames";
import isCssAnimationSupported from "../_util/isCssAnimationSupported";
import Animate from "rc-animate";
import omit from "object.omit";

export default class Spin extends React.Component {
  static defaultProps = {
    prefixCls: "ant-spin",
    spinning: true,
    size: "default",
    wrapperClassName: ""
  };
  constructor(props) {
    super(props);
    const spinning = props.spinning;
    this.state = {
      spinning,
      notCssAnimationSupported: false
    };
  }

  static propTypes = {
    className: React.PropTypes.string,
    size: React.PropTypes.oneOf(["small", "default", "large"])
  };

  isNestedPattern() {
    return !!(this.props && this.props.children);
  }

  componentDidMount() {
    if (!isCssAnimationSupported()) {
      // Show text in IE9
      this.setState({
        notCssAnimationSupported: true
      });
    }
  }

  componentWillUnmount() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    if (this.delayTimeout) {
      clearTimeout(this.delayTimeout);
    }
  }

  getSpinning(props) {
    // Backwards support
    if ("spining" in props) {
      return props.spining;
    }
    return props.spinning;
  }

  componentWillReceiveProps(nextProps) {
    const currentSpinning = this.getSpinning(this.props);
    const spinning = this.getSpinning(nextProps);
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    if (currentSpinning && !spinning) {
      this.debounceTimeout = setTimeout(() => this.setState({ spinning }), 0);
    } else {
      this.setState({ spinning });
    }
  }

  renderIndicator() {
    const { prefixCls, indicator } = this.props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && React.isValidElement(indicator)) {
      return React.cloneElement(indicator, {
        className: classNames(indicator.props.className, dotClassName)
      });
    }
    return (
      <span className={classNames(dotClassName, `${prefixCls}-dot-spin`)}>
        <i />
        <i />
        <i />
        <i />
      </span>
    );
  }

  render() {
    const {
      className,
      size,
      prefixCls,
      tip,
      wrapperClassName,
      ...restProps
    } = this.props;
    const { spinning, notCssAnimationSupported } = this.state;

    const spinClassName = classNames(
      prefixCls,
      {
        [`${prefixCls}-sm`]: size === "small",
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip || notCssAnimationSupported
      },
      className
    );

    // fix https://fb.me/react-unknown-prop
    const divProps = omit(restProps, ["spinning", "delay", "indicator"]);

    const spinElement = (
      <div {...divProps} className={spinClassName}>
        {this.renderIndicator()}
        {tip ? <div className={`${prefixCls}-text`}>{tip}</div> : null}
      </div>
    );
    if (this.isNestedPattern()) {
      let animateClassName = prefixCls + "-nested-loading";
      if (wrapperClassName) {
        animateClassName += " " + wrapperClassName;
      }
      const containerClassName = classNames({
        [`${prefixCls}-container`]: true,
        [`${prefixCls}-blur`]: spinning
      });
      return (
        <Animate
          {...divProps}
          ecId={`${this.props.ecId}_Animate@mbigvi`}
          component="div"
          className={animateClassName}
          style={null}
          transitionName="fade"
        >
          {spinning && <div key="loading">{spinElement}</div>}
          <div className={containerClassName} key="container">
            {this.props.children}
          </div>
        </Animate>
      );
    }
    return spinElement;
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/spin/index.jsx